/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Filter_EmptyInputs */



/**
* | output |
* | --- |
* | "Nobody in this selection." |
*
* @param {Team_Filter_EmptyInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const team_filter_empty = /** @type {((inputs?: Team_Filter_EmptyInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Filter_EmptyInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Niemand in deze selectie.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Personne dans cette sélection.")
	return /** @type {LocalizedString} */ ("Nobody in this selection.")
});